import { Instance } from './implementation';
export function $super(instance, superClass = instance.constructor) {
    return new Instance(instance, superClass.prototype);
}
//# sourceMappingURL=snippets.js.map